// extracted by mini-css-extract-plugin
export const title = "pick-birthday-module--title--3Ih_0";
export const intro = "pick-birthday-module--intro--3qrrn";
export const logoText = "pick-birthday-module--logoText--37t3U";
export const btnWrapper = "pick-birthday-module--btnWrapper--3bmeM";
export const birthBox = "pick-birthday-module--birthBox--Yfjmw";
export const pickDayBox = "pick-birthday-module--pickDayBox--2_X0B";
export const graphBox = "pick-birthday-module--graphBox--1szgD";
export const seeTerms = "pick-birthday-module--seeTerms--2ZU6T";
export const scrollToPickBox = "pick-birthday-module--scrollToPickBox--2e7nu";